import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditCategoryForm } from './-components/CategoryForm';

export const Route = createFileRoute('/_authenticated/categories/$id')({
    context: ({ params }) => ({
        categoryQuery: client.tenant.category.get.queryOptions(
            { params: { id: Number(params.id) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.categoryQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditCategoryForm,
});
